import { Injectable } from '@angular/core';
import * as Moment from "moment";
import * as Highcharts from "highcharts";
import * as moment from "moment-timezone";

window.moment = Moment;

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  currentTimezone: string;
  offset: string;

  constructor() {
    this.currentTimezone = moment.tz.guess();
    Highcharts.dateFormats['Z'] = (time: number): string => this.offset;
    this.timezoneChanged();
  }

  public getAllTimezones() {
    return moment.tz.names().map(zoneName => ({name: zoneName}));
  }

  public guessTimezone() {
    this.currentTimezone = moment.tz.guess();
    this.timezoneChanged();
  }

  getCurrentTimezone() {
    return this.currentTimezone;
  }

  setTimezone(newTimezone: string) {
    this.currentTimezone = newTimezone;
    this.timezoneChanged();
  }

  timezoneChanged() {
    this.offset = moment.tz(moment.utc(), this.currentTimezone).format('Z');
    Highcharts.setOptions(
      {
        time: {
          timezone: this.currentTimezone
        }
      }
    );
  }

}
